module.exports = __webpack_public_path__ + "media/jfbgvid.c4cf9a3b.webm";